import CustomerForm from '../components/CustomerForm';

export default function NewCustomer() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Create New Customer</h1>
        <p className="text-gray-600 mb-8">
          Fill out the form below to add a new customer to the system.
        </p>
        <CustomerForm />
      </div>
    </div>
  );
} 